import styled from 'styled-components';

export const HotelHastagSection = styled.section`
  margin-bottom: 30px;
`;

export const HotelHastagContainer = styled.div`
  padding: 0 25px;
  padding-bottom: 20px;
  
  border-bottom: 1px solid ${({ theme }) => theme.lightGray};
  
  @media(min-width: 768px) {
    border-bottom: 0;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
    
    border-bottom: none;
  }
`;

export const HotelHastagHeading = styled.h2`
  margin: 0;
  margin-bottom: 25px;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    
    font-size: 24px;
  }
`;

export const HotelHastagSlider = styled.div`
  margin-right: -25px;
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
    margin-right: 0;
    
    .swiper-wrapper {
      transform: none !important;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
`;

export const HotelHastagSlide = styled.div`
  max-width: 155px;
  font-size: 0;
  
  @media(min-width: 768px){
    max-width: 50%;
    margin-right: 0 !important;
    margin-bottom: 1px;
    padding-right: 1px;
    box-sizing: border-box;
  }
`;
